import React from "react";
import {Modal} from "antd";
import CreateRequestForm from "./CreateRequestForm";

const CreateRequestModal = ({visible, onClose, recall}) => (
    <Modal
        title="Yeni Ekipman Talebi"
        visible={visible}
        onCancel={onClose}
        width={800}
        footer={null}
        // Kapanışta formu sıfırlamak yerine unmount ediyoruz; her açılış temiz form ile başlar.
        destroyOnClose
    >
        <CreateRequestForm onClose={onClose} recall={recall} />
    </Modal>
);

export default CreateRequestModal;
